export default class DriveRenter {
  id!: number;
  firstName = '';
  lastName = '';
  phone = '';
  email = '';
}
